import { Observable } from "rxjs";

export abstract class ShareMessageRepo {
  /**
   * Shares a message and returs the app where the message is shared.
   * @param message
   */
  abstract shareMessage(message: string, url: string): Observable<string>;
}
